import React, { useEffect, useContext, useState } from "react";
import AppContext from "../../../store/AppContext";
import useHttp from "../../../hook/use-http";
import { API_URL_MAIN, INIT_FILTER_STATE } from '../../../constants/driveglobalfilterinitialstates_jupiter';
import { BsFillInfoCircleFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import "./Header_Jupiter.module.css";
import { useIdleTimer } from "react-idle-timer";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectLoggedInUser } from "../../../redux/userSlice";
import { FaRegListAlt } from "react-icons/fa";
import axios from "axios";
import { decodeToken } from "react-jwt";
import CustomTooltip from "../../Shared/CustomTooltip";

function Header_Jupiter(props) {
  let activeClassName = "nav-link active";
  const [headerAnalysis, setHeaderAnalysis] = useState("");
  let location = useLocation();
  let path_check = location.pathname;
  const lastSegment = path_check.split("/").pop();

  const app_ctx = useContext(AppContext);
  const [refdate, setRefDate] = useState();
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const navigate = useNavigate()

  const user = sessionStorage.getItem("user");
  const sessionToken = user ? JSON.parse(user) : null;
  let myDecodedSessionToken = decodeToken(sessionToken?.token)

  const logout = () => {
    navigate("/")
    app_ctx.logout_user();
  };
  const get_token = () => {
    let token = ''
    if (
      sessionStorage.getItem('user') != '' &&
      sessionStorage.getItem('user') != null
    ) {
      token = JSON.parse(sessionStorage.user).token
      // console.log(token);
    }
    return token
  }

  const redirectUser = async (e) => {
    // app_ctx.redirectUserToVehicleList()
    let token = get_token()
    try {
      const response = await axios.post(
        API_URL_MAIN + 'auth/logout',
        {
          log: 'logout',
          ev_bus: myDecodedSessionToken?.ev_bus
        },
        {
          headers: {
            'x-auth-token': token,
            'Content-Type': 'application/json'
          }
        }
      )
      if (response?.status === 200 || response?.status === 201) {
        navigate('/')
      }
    } catch (error) {
      console.log('Error in axios: ', error)
    }
  }

  const appyData = (data) => {
    const res_result = data;
    // console.log("Refresh date",res_result.value_as_string)
    setRefDate(res_result.value_as_string);
    refdate = res_result.value_as_string;
    // console.log("Refresh date1",refdate)
  };
  useEffect(() => {
    if (lastSegment === "Driveanalysis_Jupiter") {
      if (loggedInUser.flagForHideShow !== "ERC") {
        fetchData(
          { url: API_URL_MAIN + "jupiter_drive_analysis/refreshdate_drive", body: {} },
          appyData
        );
      } else {
        fetchData(
          { url: API_URL_MAIN + "jupiter_drive_analysis/refreshdate_drive", body: {} },
          appyData
        );
      }
    }
    if (lastSegment === "faultanalysis_jupiter") {
      fetchData(
        { url: API_URL_MAIN + "jupiter_fault_analysis/refreshdate_fault", body: {} },
        appyData
      );
    }
    if (lastSegment === "charginganalysis_jupiter") {
      fetchData(
        { url: API_URL_MAIN + "refreshdate/chargingAnalysis_jupiter", body: {} },
        appyData
      );
    }
    if (lastSegment === "ais") {
      fetchData(
        { url: API_URL_MAIN + "refreshdate/araiRefreshDate", body: {} },
        appyData
      );
    }
    if (lastSegment === "rca") {
      fetchData(
        { url: API_URL_MAIN + "rca_ace/getLastRefreshDate", body: {} },
        appyData
      );
    }
    // console.log(appyData);

    if (
      lastSegment === "Driveanalysis_Jupiter" ||
      lastSegment === "glossarypage_drive_jupiter_erc" ||
      lastSegment === "navigation_guide_jupiter"
    )
      setHeaderAnalysis("Drive Analysis");
    if (
      lastSegment === "Faultanalysis_jupiter" ||
      lastSegment === "faultanalysis_jupiter" ||
      lastSegment === "glossarypagefaultanalysis_jupiter" ||
      lastSegment === "glossarypagefaultanalysis" ||
      lastSegment === "navigation_guide_fault_jupiter"
    )
      setHeaderAnalysis("Fault Analysis");
    if (
      lastSegment === "charginganalysis" ||
      lastSegment === "glossarypagecharginganalysis" ||
      lastSegment === "navigation_guide_charging"
    )
      setHeaderAnalysis("Charging Analysis");
    if (lastSegment === "ais")
      setHeaderAnalysis("Data storage & Visualization");
    if (lastSegment === "rca" || lastSegment.length === 17)
      setHeaderAnalysis("Root Cause Analysis - ACE");
  }, []);

  useEffect(() => {
    if (lastSegment === "digitalinstrumentcluster_jupiter" || lastSegment === "navigation_guide_dic_jupiter") {
      if (props.gloablfilter !== undefined) {
        setHeaderAnalysis("Digital Instrument Cluster");
      } else {
        setHeaderAnalysis("Real Time Summary");
      }
    }

    if (lastSegment === "rangepolygon") {
      setHeaderAnalysis("Range Polygon");
    }
  }, [props.gloablfilter]);

  const handleOnIdle = (event) => {
    app_ctx.logout_user();
  };
  useIdleTimer({ timeout: 300000, onIdle: handleOnIdle, debounce: 500 });
  // window.onunload = function () {
  //   app_ctx.logout_user();
  // }

  // const interval = setInterval(function () {
  //   navigator.onLine ? console.log("") : app_ctx.logout_user();
  // }, 5000);

  const loggedInUser = useSelector(selectLoggedInUser);

  return (
    <>
      <nav className="navbar bg-white fixed-top shadow-sm px-4">
        <div className="w-100">
          <header className="topHeader d-flex flex-wrap align-items-center justify-content-between justify-content-md-between py-1 ">
            <div className="d-flex align-items-center col-md-5 mb-2 mb-md-0 text-dark text-decoration-none">
              <Link to="/homepage">
                {/* <img src="/assets/img/tml-logo.png" style={{ height: 40 }} /> */}
                <img src={process.env.PUBLIC_URL + "/assets/img/tml-logo-new.png"} style={{ height: 40 }} alt="tml-logo" />
              </Link>

              {/* {(headerAnalysis !== 'Digital Instrument Cluster') && */}
              {(headerAnalysis !== 'Real Time Summary' && headerAnalysis !== 'Digital Instrument Cluster' && headerAnalysis !== 'Range Polygon') &&
                <p className="small align-self-end mb-0">
                  Last Refresh Date:{refdate}
                </p>
              }
            </div>

            {/* <h1 className="Headfont" style={{ marginLeft: "-5%" }}></h1> */}

            {/* <h2 className="Headfont" style={{ marginRight: "8.5%" }}><strong>Drive Analysis</strong></h2> */}
            <div className="d-flex align-items-center justify-content-center col-md-4 mb-2 mb-md-0 text-dark text-decoration-none">
              <h2 className="Headfont">
                <strong>{headerAnalysis}</strong>
              </h2>
            </div>

            {/* <h2 className="Headfont" style={{ marginLeft: "-2%" }} /> */}

            {/* <div className="col-2 justify-content-end d-flex"> */}
            <div className="d-flex align-items-center justify-content-end col-md-3 mb-2 mb-md-0 text-dark text-decoration-none">
              <div className="cursor-pointer">
                <a
                  className={({ isActive }) => (isActive ? activeClassName : 'nav-link')}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    textDecoration: 'none',
                    gap: '5px'
                  }}
                  onClick={redirectUser}
                >
                  <CustomTooltip text="Back to vehicle list" placement="bottom">
                    <FaRegListAlt style={{ color: '#83a4cf', fontSize: '16px' }} />
                  </CustomTooltip>
                  {/* <span style={{ fontSize: '13px', color: 'black' }}>
                                                    <b>Project List 876543</b>
                                                  </span> */}
                </a>
              </div>
              {(lastSegment !== "rca" && lastSegment !== "rangepolygon") && (
                <div className="p-2">
                  {/* <span className="material-symbols-outlined">info</span> */}
                  {(lastSegment == "glossarypage_drive_jupiter_erc" || lastSegment == "navigation_guide_jupiter" ||
                    lastSegment == "glossarypagefaultanalysis_jupiter" || lastSegment == "navigation_guide_fault_jupiter" ||
                    lastSegment == "navigation_guide_dic_jupiter"
                  ) ? <></> :
                    <span
                      className="material-icons hand_geture"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      data-bs-offset="10,5"
                      style={{ color: " rgb(50, 135, 156)" }}
                    >
                      info
                    </span>
                  }
                  <ul className="dropdown-menu">
                    <li>
                      {/* {(lastSegment === "driveanalysis" || lastSegment === "glossarypage" || lastSegment === "navigation_guide") ? <Link className="dropdown-item d-flex align-items-center" to="/dashboard/glossarypage">
                      <span>Glossary Page</span>
                    </Link> : <></>} */}
                      {lastSegment === "Driveanalysis_jupiter" ||
                        lastSegment === "glossarypage" ||
                        lastSegment === "navigation_guide"
                        ? (
                          (
                            <Link
                              className="dropdown-item d-flex align-items-center"
                              to="/dashboard/glossarypage_drive_jupiter_erc"
                            >
                              <span>Glossary Page</span>
                            </Link>
                          )
                        ) : (
                          <></>
                        )}

                      {lastSegment === "faultanalysis_jupiter" ||
                        lastSegment === "glossarypagefaultanalysis" ||
                        lastSegment === "navigation_guide_fault" ? (
                        <Link
                          className="dropdown-item d-flex align-items-center"
                          to="/dashboard/glossarypagefaultanalysis_jupiter"
                        >
                          <span>Glossary Page</span>{" "}
                        </Link>

                      ) : (
                        <></>
                      )}
                      {lastSegment === "charginganalysis" ||
                        lastSegment === "glossarypagecharginganalysis" ||
                        lastSegment === "navigation_guide_charging" ? (
                        <Link
                          className="dropdown-item d-flex align-items-center"
                          to="/dashboard/glossarypagecharginganalysis"
                        >
                          <span>Glossary Page</span>{" "}
                        </Link>
                      ) : (
                        <></>
                      )}
                      {(lastSegment === "Driveanalysis_jupiter") |
                        (lastSegment === "glossarypage") ||
                        lastSegment === "navigation_guide" ? (
                        <Link
                          className="dropdown-item d-flex align-items-center"
                          to="/dashboard/navigation_guide_jupiter"
                        >
                          <span>Navigation Guide</span>{" "}
                        </Link>
                      ) : (
                        <></>
                      )}
                      {lastSegment === "faultanalysis_jupiter" ||
                        lastSegment === "glossarypagefaultanalysis" ||
                        lastSegment === "navigation_guide_fault" ? (
                        <Link
                          className="dropdown-item d-flex align-items-center"
                          to="/dashboard/navigation_guide_fault_jupiter"
                        >
                          <span>Navigation Guide</span>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {lastSegment === "digitalinstrumentcluster_jupiter" ? (
                        <Link
                          className="dropdown-item d-flex align-items-center"
                          to="/realtime_jupiter/navigation_guide_dic_jupiter"
                        >
                          <span>Navigation Guide</span>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {lastSegment === "charginganalysis" ||
                        lastSegment === "glossarypagecharginganalysis" ||
                        lastSegment === "navigation_guide_charging" ? (
                        <Link
                          className="dropdown-item d-flex align-items-center"
                          to="/dashboard/navigation_guide_charging"
                        >
                          <span>Navigation Guide</span>
                        </Link>
                      ) : (
                        <></>
                      )}
                      {lastSegment === "digitalinstrumentcluster" ||
                        lastSegment === "navigation_guide_dic" ? (
                        <Link
                          className="dropdown-item d-flex align-items-center"
                          to="/realtime/navigation_guide_dic"
                        >
                          <span>Navigation Guide</span>
                        </Link>
                      ) : (
                        <></>
                      )}
                    </li>
                    <li>
                      {/* <a className="dropdown-item d-flex align-items-center" href="#">
                <span className="material-icons">info_outline</span>
                <span className="ms-2">Support </span>
              </a> */}
                    </li>
                  </ul>
                </div>
              )}

              <div>
                <a href="/">
                  <img
                    src={process.env.PUBLIC_URL + "/assets/img/sp-logo.png"}
                    style={{ height: 45 }}
                  />
                </a>
              </div>
              <div className="p-2">
                <span
                  className="material-icons dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  data-bs-offset="10,5"
                >
                  person
                </span>
                <ul className="dropdown-menu">
                  <li>
                    <a
                      className="dropdown-item d-flex align-items-center"
                      href="javascript:void(0);"
                      onClick={logout}
                    >
                      <span className="material-icons">logout</span>
                      <span className="ms-2">Logout </span>
                    </a>
                  </li>
                  <li>
                    {/* <a className="dropdown-item d-flex align-items-center" href="#">
                <span className="material-icons">info_outline</span>
                <span className="ms-2">Support </span>
              </a> */}
                  </li>
                </ul>
              </div>
            </div>
          </header>
        </div>
      </nav >
    </>
  );
}

export default Header_Jupiter;
